import { Component, OnDestroy, OnInit } from '@angular/core'
import { NavigationEnd, Router } from '@angular/router'
import { DialogService } from '@shared/services/dialog.service'
import { InfoService } from '@shared/services/info.service'
import { PopupService } from '@shared/services/popup.service'
import { ResultService } from '@shared/services/result.service'
import { combineLatest, Subject } from 'rxjs'
import { filter, map, takeUntil } from 'rxjs/operators'

@Component({
    selector: 'inka-app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  destroyed$: Subject<any> = new Subject<any>()

  constructor(
    private router: Router,
    private dialog: DialogService,
    private info: InfoService,
    private popup: PopupService,
    private result: ResultService) {
  }

  ngOnInit() {
    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        takeUntil(this.destroyed$))
      .subscribe((e) => {
        document.scrollingElement?.scrollTo({ top: 0 });
      });

    combineLatest([
      this.dialog.dialogContent$.pipe(map(content => !!content)),
      this.info.visible$,
      this.popup.visible$,
      this.result.visible$,
    ])
      .pipe(
        map(visible => visible.some(x => x)),
        takeUntil(this.destroyed$))
      .subscribe(visible => {
        visible ?
          document.body.classList.add('non-scrollable') :
          document.body.classList.remove('non-scrollable')
      })
  }

  ngOnDestroy() {
    this.destroyed$.next(undefined)
    this.destroyed$.complete()
  }
}
